import { useCallback, useContext, useState } from 'react';
import { RouterContext } from './Provider';
import { useSubscription } from './useSubscription';
/**
 * Возращает экземляр роутера
 */
export function useRouter() {
    const router = useContext(RouterContext);
    const [globalPath, setPath] = useState(router.getPath());
    const onChange = useCallback(({ path }) => {
        if (globalPath !== path && path !== undefined) {
            setPath(path);
        }
    }, [globalPath]);
    useSubscription(onChange);
    return router;
}
